var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('Statistics',{attrs:{"application":_vm.data.application,"offer":_vm.data.offer,"is-loading":_vm.$store.state.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }